import { CMB, CMB_MODE } from './types';
import store from '../../../helpers/store';
import Tracker from '../../../genesys/tracker';
import IPC from '../../../helpers/ipc';
import Logger from '../../../../common/logger';
import String from '../../../../common/String';
import { MAIN_ACTIONS } from '../../main/types';

export const saveMode = (mode) => {
    store.dispatch({
        type: CMB.SAVE_MODE,
        data: {
            mode: mode
        }
    });
};

export const savePhone = (phone, isPhoneValid) => {
    store.dispatch({
        type: CMB.SAVE_PHONE,
        data: {
            phone: phone,
            isPhoneValid: isPhoneValid
        }
    });
};

export const saveDate = (date, timeRange) => {
    store.dispatch({
        type: CMB.SAVE_DATE,
        data: {
            date: date,
            timeRange: timeRange
        }
    });
};

export const saveConsent = (data) => {
    store.dispatch({
        type: CMB.SAVE_CONSENT,
        data: data
    });
};

export const saveValidationState = (isFormValid) => {
    store.dispatch({
        type: CMB.SAVE_VALIDATION_STATE,
        data: {
            isFormValid: isFormValid
        }
    });
};

export const saveSubmittedState = () => {
    store.dispatch({
        type: CMB.SAVE_SUBMITTED_STATE
    });
};

export const saveCountdownRemaining = (remaining) => {
    store.dispatch({
        type: CMB.SAVE_COUNTDOWN_REMAINING,
        data: {
            remaining: remaining
        }
    });
};

export const resetStore = () => {
    store.dispatch({
        type: CMB.RESET
    });
};

export const setInitMode = (config) => {
    const cmbOptions = [];
    Object.keys(CMB_MODE).forEach((m) => {
        if (config[`cmb${String.capitalizeFirstLetter(m)}Available`]) {
            cmbOptions.push(m);
        }
    });

    if (cmbOptions.length === 1) {
        saveMode(cmbOptions[0]);
        Logger.log(`setInitCMBMode: ${cmbOptions[0]}`);
    }
};

export const sendGTMEvent = (event, source) => {
    Tracker.sendViewResult('callback', event, source);
};

export const sendTrackerEvent = (mode, data) => {
    if (mode === CMB_MODE.IMMEDIATE) {
        Tracker.sendEvent('widgetCmbImmediateAdd', data);
    } else {
        Tracker.sendEvent('widgetCmbDelayedAdd', data);
    }
    sendGTMEvent('leadCMBSubmitted', 'CMB');
};

export const openURL = (url, self = false) => {
    IPC.sendEvent(MAIN_ACTIONS.OPEN_URL, { url, self });
};
